import React from 'react';

interface PasswordStrengthIndicatorProps {
  password: string;
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ password }) => {
  // Define strength levels based on validation criteria
  const getPasswordStrength = (password: string) => {
    if (!password) return 0;

    let strength = 0;

    // Check for length
    if (password.length >= 8) strength += 1;

    // Check for lowercase and uppercase letters
    if (/(?=.*[a-z])/.test(password) && /(?=.*[A-Z])/.test(password)) strength += 1;

    // Check for numbers and special characters
    if (/(?=.*[0-9])/.test(password) && /(?=.*[!@#$%^&*])/.test(password)) strength += 1;

    return strength;
  };

  const strength = getPasswordStrength(password);

  return (
    <div className="flex flex-row items-center gap-2 mt-2">
      <div
        className="w-12 h-2 rounded-full"
        style={{
          backgroundColor: strength >= 1 ? '#4CAF50' : '#F0F4F2',
        }}
      ></div>
      <div
        className="w-12 h-2 rounded-full"
        style={{
          backgroundColor: strength >= 2 ? '#4CAF50' : '#F0F4F2',
        }}
      ></div>
      <div
        className="w-12 h-2 rounded-full"
        style={{
          backgroundColor: strength >= 3 ? '#4CAF50' : '#F0F4F2',
        }}
      ></div>
    </div>
  );
};

export default PasswordStrengthIndicator;